export const LOAD_POPULAR_CONTENT =
  'editorAC/CategoryPageContainer/LOAD_POPULAR_CONTENT';

export const LOAD_POPULAR_CONTENT_SUCCESS =
  'editorAC/CategoryPageContainer/LOAD_POPULAR_CONTENT_SUCCESS';

export const LOAD_NEW_CONTENT =
  'editorAC/CategoryPageContainer/LOAD_NEW_CONTENT';

export const LOAD_NEW_CONTENT_SUCCESS =
  'editorAC/CategoryPageContainer/LOAD_NEW_CONTENT_SUCCESS';

export const LOAD_SEARCH_CONTENT =
  'editorAC/CategoryPageContainer/LOAD_SEARCH_CONTENT';

export const LOAD_SEARCH_CONTENT_SUCCESS =
  'editorAC/CategoryPageContainer/LOAD_SEARCH_CONTENT_SUCCESS';
